import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest,
    HttpHeaders
} from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { AuthService } from '../services/auth-service';
import { Environment, ENVIRONMENT } from '@classifieds-sell/environment';

const AUTH_HEADER_NAME = 'Authorization';
const CACHE_CONTROL = 'Cache-Control';
const CACHE_CONTROL_VALUE = 'no-cache, no-store, must-revalidate';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    private _authManager: AuthService;

    constructor( @Inject(ENVIRONMENT) private env: Environment) {
        this._authManager = new AuthService(this.env);
    }

    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        if (!request.withCredentials) {
            return next.handle(request);
        }

        const setHeaders = (authToken: string, headers: HttpHeaders) => {
            return (
                headers
                    .set(AUTH_HEADER_NAME, authToken)
                    // prevent caching in IE, in particular IE11.
                    .set(CACHE_CONTROL, CACHE_CONTROL_VALUE)
            );
        };

        return from(this._authManager.authToken()).pipe(
            mergeMap((token) =>
                next.handle(
                    request.clone({
                        headers: setHeaders(token, request.headers)
                    })
                )
            )
        );
    }
}
